import React from "react";
import { cn } from "../../lib/cn";
import { SecondaryLink } from "./Buttons";
import { MAPS_DIRECTIONS_URL } from "../../lib/businessInfo";

/**
 * Opens Google Maps directions in a new tab.
 */
export default function DirectionsButton({ className, ...rest }) {
  return (
    <SecondaryLink
      href={MAPS_DIRECTIONS_URL}
      className={cn("directions-button", "w-full sm:w-auto", className)}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
      data-gtm="directions-click"
    >
      Directions
    </SecondaryLink>
  );
}
